export default "__VITE_ASSET__qDos3DFf__"